import { render, staticRenderFns } from "./ServicesLoader.vue?vue&type=template&id=427715c6&"
import script from "./ServicesLoader.vue?vue&type=script&lang=js&"
export * from "./ServicesLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports